<template>
  <main>
   <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
   <div class="game-result" v-if="windowWidth > 767" id="scrollToOnLoad">
    <b-container>
      <section class="info__box">
        <img class="mr-3 info__ico" src="@/assets/ico-click.png" alt="">
        <div>
          <h2>{{ $t("results.well") }}</h2>
          <p class="text--small">
            {{ $t("results.content") }}
          </p>
        </div>
      </section>
      <board :isEditable="isEditable"></board>
    </b-container>
   </div>
   <div v-if="windowWidth <= 767" class="container">
      <div class="alert alert-warning">
        {{ $t("buildingBlocks.alert") }}
      </div>
    </div>
  </main>
</template>

<script>
import Hero from '@/components/Hero';
import Article from '@/components/Article';
import Board from '@/views/Game/Results/Board';

export default {
  data() {
    return {
      bgImg: 'Banner2-Experiment-',
      subtitle: this.$t('nav.experiment'),
      windowWidth: null,
      article: {
        photo: 'img-results.jpg',
        title: 'Results',
        header: 'Information on forming a hypothesis, defining parameters, design the experiments, drawing conclusions',
      },
    };
  },
  components: {
    'section-hero': Hero,
    'section-article': Article,
    Board,
  },
  computed: {
    isEditable() { return this.$route.name === 'results'; },
  },
  methods: {
    getWindowWidth() {
      this.windowWidth = document.documentElement.clientWidth;
    },
  },
  created() {
    this.getWindowWidth();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
.game-result {
  background-color: $color--gray-6;
  padding: 100px 0;
}
.info {
  &__box {
    background-color: $color--white-1;
    padding: 30px 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  &__ico {
     width: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Game/Results/Index.vue